export const VERIFICATION_TEMPLATE_IDS = [
    'SWM_VIOLET',
    'STANDARD_CARD',
    'MINIMAL_BADGE',
    'DIPLOMA_ELEGANT',
    'DIPLOMA_WIDE',
    'TRUST_PANEL',
] as const;

export type VerificationTemplateId = (typeof VERIFICATION_TEMPLATE_IDS)[number];

export type VerificationTemplateOption = {
    id: VerificationTemplateId;
    label: string;
    description?: string;
};

export const VERIFICATION_TEMPLATE_OPTIONS: VerificationTemplateOption[] = [
    {
        id: 'SWM_VIOLET',
        label: 'Hero (Gradient)',
        description: 'Centered hero layout with configurable gradient background',
    },
    {
        id: 'STANDARD_CARD',
        label: 'Card (QR)',
        description: 'Card layout with certificate details and QR code',
    },
    {
        id: 'MINIMAL_BADGE',
        label: 'Minimal',
        description: 'Compact verification layout',
    },
    {
        id: 'DIPLOMA_ELEGANT',
        label: 'Diploma (Certificate Preview)',
        description: 'Displays the issued certificate artwork prominently in a bordered diploma card, with status, dates, QR and verification details below. Uses tenant tint colors and logo.',
    },
    {
        id: 'DIPLOMA_WIDE',
        label: 'Diploma (Wide)',
        description: 'Wider desktop layout on a subtly branded backdrop: shows the issued certificate image, status, competency, dates, verification details, and a prominent blockchain-explorer button. Responsive to a single column on mobile.',
    },
    {
        id: 'TRUST_PANEL',
        label: 'Trust panel',
        description: 'Mobile-first two-column layout built for QR scans: status, holder, competency and issuer are all above the fold, with the artwork alongside and the on-chain provenance presented as supporting detail rather than the headline. Existing tenants are unaffected unless they select it.',
    },
];

export function coerceVerificationTemplateId(value: string | null | undefined): VerificationTemplateId | null {
    if (!value) return null;
    return (VERIFICATION_TEMPLATE_IDS as readonly string[]).includes(value)
        ? (value as VerificationTemplateId)
        : null;
}
